import { useTranslation } from '@ecomm/i18n'
import { ComparisonCell } from '../ComparisonCell'
import { ComparisonRow } from '../ComparisonRow'

export function RowUniquePins() {
  const { t } = useTranslation('maps')

  return (
    <ComparisonRow
      title={t('feature-title.unique-pins-business')}
      description={t('feature-description.unique-pins-business')}
    >
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
    </ComparisonRow>
  )
}
